import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useQuery } from '@tanstack/react-query';
import { auditApi } from '../../api/auditApi';
import { AuditLogTable } from './AuditLogTable';

interface Props {
  open: boolean;
  resultId: number | null;
  onClose: () => void;
}

export const ResultHistoryDialog = ({ open, resultId, onClose }: Props) => {
  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'audit', 'result', resultId],
    queryFn: () => auditApi.resultHistory(resultId!),
    enabled: open && resultId != null,
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6" component="span">Historie výsledku</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <AuditLogTable entries={data ?? []} compact />
        )}
      </DialogContent>
    </Dialog>
  );
};
